import { buildFinancialProductSchema } from '../types/FinancialProduct'

/**
 * Generates schema for ProductPage
 * @param {Object} data - Page data object
 */
export default function ProductPageSchema(data) {
    if (!data) {
        return null
    }

    // Only build FinancialProduct schema if page contains the product category.
    let isProduct = Array.isArray(data.Category) && data.Category.find(x => x?.Name?.match && x.Name.match(/product/i));
    if (isProduct) {

        //Extract URL from data.Url if available, otherwise use window.location.href (client-side only)
        let url = data.Url?.Href || null
        if (!url && typeof window !== 'undefined') {
            url = window.location.href
        }

        //Build options object for FinancialProduct schema
        const options = {
            id: url,
            name: data.Name,
            description: data.MetaDescription
        }

        return buildFinancialProductSchema(options)
    }

    return null
}